import { render, staticRenderFns } from "./font-selector.vue?vue&type=template&id=d14daa74&scoped=true&"
import script from "./font-selector.vue?vue&type=script&lang=js&"
export * from "./font-selector.vue?vue&type=script&lang=js&"
import style0 from "./font-selector.vue?vue&type=style&index=0&id=d14daa74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14daa74",
  null
  
)

export default component.exports